import * as Api from '@ViewModels';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { Checkbox } from '../../../../components-v2/Checkbox';
import { grayIconFill } from '../../../../styles/colors';

export interface ScoreFilterState {
	showSuppressed: boolean;
	ownerOnly: boolean;
}

interface ScoreFiltersProps {
	filters: ScoreFilterState;
	onChange: (filters: ScoreFilterState) => void;
}

export const ScoreFilters: React.FC<ScoreFiltersProps> = ({ filters, onChange }) => {
	const userSession = useUserSession();
	const isAdmin = userSession.userRole === Api.EUserRole.Admin || userSession.userRole === Api.EUserRole.SuperAdmin;

	return (
		<div className={css(s.container)}>
			<label className={css(s.filterLabel)}>
				<Checkbox
					checked={filters.showSuppressed}
					onCheckedChange={(checked: boolean) => onChange({ ...filters, showSuppressed: checked })}
				/>
				<span className={css(s.filterText)}>Show suppressed contacts</span>
			</label>
			{isAdmin ? (
				<label className={css(s.filterLabel)}>
					<Checkbox
						checked={filters.ownerOnly}
						onCheckedChange={(checked: boolean) => onChange({ ...filters, ownerOnly: checked })}
					/>
					<span className={css(s.filterText)}>My contacts only</span>
				</label>
			) : null}
		</div>
	);
};

const s = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: 16,
		marginBottom: 12,
	},
	filterLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		cursor: 'pointer',
	},
	filterText: {
		fontSize: 13,
		color: grayIconFill,
	},
});
